import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { StartFormInfobox } from '../utils/start-form-infobox';
import { StartFormFile } from '../utils/start-form-file';

export const SigningOfContractAndInvoicePayment = () => {
  const { t } = useTranslations();

  return (
    <div className="flex flex-col gap-10">
      <h1 className="py-4 text-3xl font-bold sm:py-6 sm:text-4xl md:text-5xl">{t('text1210')}</h1>
      <div className="flex flex-col gap-3">
        <StartFormInfobox type="destructive" textDescructive="text1221" textSuccess="text1223" />
        <StartFormInfobox type="destructive" textDescructive="text1222" textSuccess="text1224" />
      </div>
      <div className="flex flex-col gap-4">
        <h1 className="text-sm font-bold">{t('text1225')}</h1>
        <StartFormFile filename="Zmluva_o_dielo_XX.pdf" />
        <StartFormFile filename="Faktúra_XX.pdf" />
      </div>
    </div>
  );
};
